module.exports = __webpack_public_path__ + "img/stok_supplier.d71d9f3c.svg";